import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { Amplify } from 'aws-amplify';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { awsConfig } from '@utils/aws';
import App from './App';
import reportWebVitals from './reportWebVitals';

Sentry.init({
  dsn: 'https://4153941382ff44028646f1a30f80ca1f@o1088776.ingest.sentry.io/6103547',
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 0.8,
});

Amplify.configure(awsConfig);

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
